export default "__VITE_ASSET__DTS4_8m2__"